export default __webpack_public_path__ + "images/6327828115106500a4b7dddc27e64780-christmas.jpg";